import { render } from "./InclusaoEdicao.vue?vue&type=template&id=9482036c&ts=true"
import script from "./InclusaoEdicao.vue?vue&type=script&lang=ts"
export * from "./InclusaoEdicao.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__